import { Link } from "react-router-dom";
import { BUSINESS } from "../data/business";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-gold/20 bg-night">
      <div>
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-10 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-5 flex items-start gap-4">
            <span className="h-14 w-14 rounded-full overflow-hidden ring-1 ring-gold/40 shrink-0"><img src="/img/logo.jpg" alt="" className="h-full w-full object-cover scale-[1.9] translate-y-[10%]" /></span>
            <div>
              <p className="font-display text-2xl text-saffron">{BUSINESS.name}</p>
              <p className="text-xs text-ivory/50 mt-1">{BUSINESS.tagline} · Wholesale & retail CVD / HPHT lab grown diamonds · IGI certified</p>
              <p className="text-xs text-ivory/50 mt-3 leading-relaxed">{BUSINESS.addressLines.join(", ")}</p>
            </div>
          </div>
          <div className="md:col-span-3 text-sm space-y-2">
            <p className="eyebrow mb-3">Pages</p>
            {[["Home", "/"], ["Browse Stones", "/browse"], ["Bulk Order", "/bulk-order"], ["About Us", "/about"], ["Enquiry", "/enquiry"], ["Admin", "/admin"]].map(([l, h]) => (
              <Link key={l} to={h} className="block text-ivory/70 hover:text-saffron transition-colors" data-testid={`footer-link-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</Link>
            ))}
          </div>
          <div className="md:col-span-4 text-sm space-y-2">
            <p className="eyebrow mb-3">Registered</p>
            <p className="text-ivory/70">GSTIN {BUSINESS.gst}</p>
            <p className="text-ivory/70">Shop Reg. {BUSINESS.shopReg}</p>
            <p className="text-ivory/70">Mob. {BUSINESS.phone}</p>
          </div>
        </div>
        <p className="text-center text-[10px] uppercase tracking-[0.3em] text-ivory/30 pb-8">© 2026 {BUSINESS.name} · Lab-grown diamonds · Hyderabad</p>
      </div>
    </footer>
  );
};
